const services = [
  {
    "title": "Eldstäder",
    "intro": "Vill du installera en ny eldstad eller behöver du hjälp med en befintlig? Vi hjälper dig med montering, installation och byggnation av kaminer, vedspisar, kakelugnar och bakugnar. Tillsammans hittar vi en lösning som passar ditt hus och dina önskemål.",
    "items": [
      "Kaminer",
      "Vedspisar",
      "Kakelugnar",
      "Bakugnar"
    ]
  },
  {
    "title": "Renovering av rökkanaler",
    "intro": "En äldre rökkanal kan behöva renoveras för att fungera säkert tillsammans med eldstaden. Vi arbetar med glidgjutning och flexibla insatsrör och hjälper dig att välja metod utifrån kanalens skick och förutsättningar. Vi utför även installation av rökkanaler.",
    "items": [
      "Glidgjutning",
      "Flexibla insatsrör"
    ]
  },
  {
    "title": "Skorstenar",
    "intro": "Vi renoverar skorstenar genom ommurning, lagning och omfogning. Arbetet anpassas efter skorstenens skick, material och vilka delar som behöver åtgärdas. Kontakta oss för att diskutera vad din skorsten behöver.",
    "items": [
      "Ommurning",
      "Lagning",
      "Omfogning"
    ]
  },
  {
    "title": "Fasadrenovering",
    "intro": "Behöver fasaden lagas eller få en mer omfattande renovering? Vi hjälper dig med tilläggsisolering, fasadmurning, lagning och färgning. Material och utförande anpassas efter den befintliga fasaden och husets förutsättningar.",
    "items": [
      "Tilläggsisolering",
      "Fasadmurning",
      "Lagning",
      "Färgning"
    ]
  },
  {
    "title": "Murning & putsning",
    "intro": "Vi utför mur- och putsarbeten med respekt för hantverket och materialens egenskaper. Varje arbete anpassas efter byggnaden och det resultat du vill uppnå. Berätta om ditt projekt, så går vi tillsammans igenom möjliga lösningar.",
    "items": []
  }
];

export default function Services() {
  return (
    <article id="tjanster" className="invert">
      <section className="services-section">
        <h2 id="tjanster_title">Tjänster</h2>
        <p>Från en ny eldstad till en renoverad fasad – vi hjälper dig att hitta rätt lösning.</p>
        <div className="service-grid">
          {services.map(service => (
            <div className="service-card" key={service.title}>
              <h3>{service.title}</h3>
              {service.intro && <p>{service.intro}</p>}
              {service.items.length > 0 && <ul>{service.items.map(item => <li key={item}>{item}</li>)}</ul>}
            </div>
          ))}
        </div>
      </section>
      <section className="services-section method-section" aria-label="Metoder för renovering av rökkanaler">
        <div className="method-grid">
          <div className="method-card">
            <h3>Renovering med glidgjutning</h3>
            <div className="method-illustration">
              <img src="/images/glidgjutning.webp" alt="Glidgjutning av rökkanal" width="200" height="202" style={{ height: "auto" }} loading="lazy" />
            </div>
            <p>Vid glidgjutning tätas den befintliga rökkanalen med en keramisk tätningsmassa. Metoden används för att renovera kanalen och bevara dess area och värmespridning i murstocken.</p>
          </div>
          <div className="method-card">
            <h3>Renovering med flexibelt insatsrör</h3>
            <div className="method-illustration">
              <img src="/images/insatsror.webp" alt="Insatsrör i rökkanal" width="200" height="202" style={{ height: "auto" }} loading="lazy" />
            </div>
            <p>Ett flexibelt insatsrör är ett rostfritt, syrafast och böjbart rör som monteras i den befintliga rökkanalen. Utrymmet runt röret isoleras med vermikulit. Vi hjälper dig att bedöma vilken metod som passar din rökkanal.</p>
          </div>
        </div>
        <div className="service-offer-action">
          <a className="cta-link service-offer-link" href="#offert">Begär offert</a>
        </div>
      </section>
    </article>
  );
}
